import request, { type ApiResponse } from "@/utils/request";

// 获取Comment
export const getComments = (doorCode: string, batchId: string, taskId: string, type: string): Promise<ApiResponse<any>> => {
  return request.get(`/app/activiti/getComments/${doorCode}/${batchId}/${taskId}`, { type });
};

export const modifyComments = (data: any): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/modifyComments', data);
};

export const clearComments = (data: any): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/comment/clear', data);
};
